// extracted by mini-css-extract-plugin
export default {"buttons":"ReceivablePublicAnnouncementPublishedComponent_buttons__Rqam0"};